"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseDisputeBuyerModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _client = require("@apollo/client");
var _dsWeb = require("@olxbr/ds-web");
var _platform = require("../../../../helpers/platform");
var _linking = require("../../../../helpers/linking");
var _actions = require("../../../../actions");
var _ButtonsWrapper = require("./ButtonsWrapper");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject;
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var CLOSE_DISPUTE = (0, _client.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation CloseDispute($decision: String!, $disputeId: String!) {\n    closeDispute(decision: $decision, disputeId: $disputeId) {\n        success\n    }\n  }\n"])));
var CloseDisputeBuyerModal = exports.CloseDisputeBuyerModal = function CloseDisputeBuyerModal(_ref) {
  var buyerOptions = _ref.buyerOptions,
    disputeId = _ref.disputeId;
  var _React$useState = _react["default"].useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedOption = _React$useState2[0],
    setSelectedOption = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    selectedValue = _React$useState4[0],
    setSelectedValue = _React$useState4[1];
  var _useMutation = (0, _client.useMutation)(CLOSE_DISPUTE),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    closeDisputeMutation = _useMutation2[0];
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.clickDisputeModalFeedbackSend)(false));
    dispatch((0, _actions.impressionDisputeModalFeedback)(false));
    return function () {
      dispatch((0, _actions.clickDisputeModalFeedbackClose)(false));
    };
  }, []);
  var openOptionLink = function openOptionLink() {
    var _buyerOptions$selecte;
    if (buyerOptions !== null && buyerOptions !== void 0 && (_buyerOptions$selecte = buyerOptions[selectedOption]) !== null && _buyerOptions$selecte !== void 0 && _buyerOptions$selecte.url) {
      (0, _linking.openLink)(buyerOptions[selectedOption].url);
    }
  };
  var handleButtonClick = function handleButtonClick() {
    if (!selectedValue) {
      openOptionLink();
    } else {
      closeDisputeMutation({
        variables: {
          decision: selectedValue,
          disputeId: disputeId
        }
      }).then(function () {
        openOptionLink();
      });
    }
    dispatch((0, _actions.closeModal)());
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
    flexDirection: "column",
    gap: "--spacing-2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.SubtitleMedium, {
      children: "Como finalizou seu acordo?"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Flex, {
      flexDirection: "column",
      gap: "--spacing-1",
      padding: "--spacing-1",
      style: {
        overflowY: 'auto'
      },
      children: buyerOptions.map(function (option, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Radio, {
            value: option.value,
            label: option.label,
            checked: index === selectedOption,
            onChange: function onChange() {
              setSelectedOption(index);
              setSelectedValue(option.value);
            }
          }, index), index < buyerOptions.length - 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Divider, {})]
        });
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonsWrapper.ButtonsWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Button, {
        onClick: handleButtonClick,
        fullWidth: _platform.isMsite,
        disabled: selectedOption === null,
        children: "Encerrar acordo"
      })
    })]
  });
};